import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_225: DocMigration = {
  maxSchemaVersion: "0.0.225",
  description: "Change name of apronWidth to apronHeight",
  apply(json: any) {
    function renameProp(setting: any) {
      if (setting?.apronWidth !== undefined) {
        setting.apronHeight = setting.apronWidth;
        delete setting.apronWidth;
      }
    }

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "EXTERIOR_WINDOW_CASING_SETTINGS" || setting.type === "EXTERIOR_DOOR_CASING_SETTINGS") {
        // update settings
        renameProp(setting);
      } else if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        // update door types
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          if (windowType) {
            renameProp(windowType.exteriorCasing);
          }
        }
      } else if (setting.type === "DOOR_CATALOG_SETTINGS") {
        // update window types
        for (const doorTypeId in setting.doorTypes) {
          const doorType = setting.doorTypes[doorTypeId];
          if (doorType) {
            renameProp(doorType.exteriorCasing);
          }
        }
      }
    }

    // update instances
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening) {
        renameProp(opening.exteriorCasing);
      }
    }

    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];
      if (opening) {
        renameProp(opening.exteriorCasing);
      }
    }

    for (const openingId in json.dormers) {
      const opening = json.dormers[openingId];
      if (opening) {
        renameProp(opening.exteriorCasing);
      }
    }

    return json;
  },
};

export default migration_0_0_225;
